import { Menu, type MenuItem } from './Menu'

export interface BarTab {
  id: string
  label: string
  icon: string
}

interface Props {
  tabs: BarTab[]
  active: string
  onSelect: (id: string) => void
  /** Everything that does not earn a slot in the bar. */
  more: MenuItem[]
  moreActive: boolean
}

/**
 * The phone's bottom bar: the four places a parent goes every week, and More
 * for the rest. Fixed to the bottom with the safe-area inset, so it sits above
 * the home indicator rather than under it.
 */
export function TabBar({ tabs, active, onSelect, more, moreActive }: Props) {
  return (
    <nav className="tabbar" aria-label="Sections">
      {tabs.map((t) => (
        <button key={t.id} type="button" className="tabbar-item" aria-current={active === t.id ? 'page' : undefined} onClick={() => onSelect(t.id)}>
          <span className="tabbar-icon" aria-hidden="true">
            {t.icon}
          </span>
          <span className="tabbar-label">{t.label}</span>
        </button>
      ))}
      <Menu
        trigger={
          <>
            <span className="tabbar-icon" aria-hidden="true">
              ⋯
            </span>
            <span className="tabbar-label">More</span>
          </>
        }
        label="More"
        items={more}
        className={`tabbar-item ${moreActive ? 'is-active' : ''}`}
        align="right"
      />
    </nav>
  )
}
